export default __webpack_public_path__ + "static/media/09_BUKAVU_02-min.210a6223.jpg";